import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { VueTelInput } from 'vue-tel-input';
/**
 * Phone Input Component
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.3.0}
 */
let PhoneInput = class PhoneInput extends Vue {
    onValidate(validate) {
        this.$emit('valid', validate.valid);
    }
};
__decorate([
    Prop({ type: Number, default: 13 })
], PhoneInput.prototype, "length", void 0);
__decorate([
    Prop({ type: String, default: '' })
], PhoneInput.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: '' })
], PhoneInput.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: 'Enter Phone Number' })
], PhoneInput.prototype, "placeholder", void 0);
__decorate([
    Prop({ type: String, default: '' })
], PhoneInput.prototype, "color", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PhoneInput.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, default: '' })
], PhoneInput.prototype, "hint", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PhoneInput.prototype, "persistentHint", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], PhoneInput.prototype, "errorMessages", void 0);
PhoneInput = __decorate([
    Component({
        components: {
            VueTelInput,
        },
    })
], PhoneInput);
export default PhoneInput;
